import { Injectable } from '@angular/core';
import { DrawerNavigation } from '@shared/types';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class ListNavigationService {
    private index = -1;

    navigationData: BehaviorSubject<DrawerNavigation | null> = new BehaviorSubject<DrawerNavigation | null>(null);
    onNextPage: Subject<void> = new Subject<void>();
    onPreviousPage: Subject<void> = new Subject<void>();
    onNewItem: Subject<any> = new Subject<any>();

    resetNavigationData() {
        this.navigationData.next(null);
        this.index = -1;
    }

    getNavigationData(): DrawerNavigation | null {
        return this.navigationData.value;
    }

    setNavigationData(data: DrawerNavigation) {
        this.navigationData.next(data);
    }

    getIndex(): number {
        return this.index;
    }

    setIndex(index: number) {
        this.index = index;
    }

    setItem(item: any) {
        if (!this.navigationData.value) {
            return;
        }

        this.index = this.navigationData.value.data.indexOf(item);
        this.onNewItem.next(item);
    }

    searchItemInList(id: string) {
        if (!this.navigationData.value) {
            return;
        }

        return this.navigationData.value.data.find((el: any) => el.id.toString() === id);
    }

    goNextItem() {
        if (!this.navigationData.value) {
            return;
        }

        this.index = this.index + 1;

        if (this.index >= this.navigationData.value.take) {
            this.onNextPage.next();
            this.index = 0;
            return;
        }

        this.onNewItem.next(this.navigationData.value.data[this.index]);
    }

    goPreviousItem() {
        if (!this.navigationData.value) {
            return;
        }

        this.index = this.index - 1;

        if (this.index === -1) {
            this.onPreviousPage.next();
            this.index = this.navigationData.value.take - 1;
            return;
        }

        this.onNewItem.next(this.navigationData.value.data[this.index]);
    }
}
